/* eslint-disable import/no-unresolved */
import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { Keycloak } from 'Services';
import ReactDOM from 'react-dom';
import 'Styles/index.scss';
import { SDPProvider } from 'Contexts';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <ReactKeycloakProvider authClient={Keycloak}>
      <SDPProvider>
        <App />
      </SDPProvider>
    </ReactKeycloakProvider>
  </React.StrictMode>,
  document.querySelector('#root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
